import React from "react";

const userContext = React.createContext({ user: {} });
userContext.displayName = "UserContext";

export default userContext;
